export default function DownloadButton({
  onClick,
  disabled,
  label = "Download for Excel",
}: {
  onClick: () => void;
  disabled?: boolean;
  label?: string;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="inline-flex items-center gap-1 rounded-md border border-ink-200 bg-white px-2.5 py-1 text-xs font-medium text-ink-700 transition hover:border-ink-300 disabled:cursor-not-allowed disabled:opacity-50"
      title="Download this table as a CSV (opens in Excel)"
    >
      <span aria-hidden>⬇</span> {label}
    </button>
  );
}
